import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AttributeTypes } from '../../../../modules/shared/enums/attribute-types';
import { IAnalyticQuery } from '../../interfaces/IAnalyticsQuery';
import { IAnalyticsResult } from '../../interfaces/IAnalyticsResult';
import { AnalyticsColumn } from '../../models/analytics-column';
import { AnalyticsMenuItemChild } from '../../models/analytics-menu-item-child';
import { AnalyticsService } from '../../services/analytics.service';
import { AnalyticsDataSource } from '../analytics-filter/analytics-data-source';

@Component({
  selector: 'app-analytics-execution',
  templateUrl: './analytics-execution.component.html',
  styleUrls: ['./analytics-execution.component.css']
})
export class AnalyticsExecutionComponent implements OnInit {    
  constructor(
    private activatedRoute: ActivatedRoute,
    private analyticsService: AnalyticsService
  ) {
    this.parentId = this.activatedRoute.snapshot.params['parentId'];
   }

   public parentId: string
   public result: IAnalyticsResult<any>;
   public dataSource:AnalyticsDataSource<any> = null; 
   public activeElement: AnalyticsMenuItemChild = null;
   public displayedColumns = null;
   public columns: AnalyticsColumn[];

  ngOnInit() {
    if(this.parentId){
      this.analyticsService.getElement(this.parentId).subscribe(() => {
      })
    }
  }
  onElementChange(item: AnalyticsMenuItemChild) {    
    if(item && this.activeElement !== item){
      this.activeElement = item;
      this.dataSource = new AnalyticsDataSource<any>(this.analyticsService, item.id);
      this.analyticsService.getInfo(item.id).subscribe(result => {
        if(result){
          this.columns = result.columns;
          if(result.columns){
            let displayedColumns = [];
            result.columns.forEach(column => {
              displayedColumns.push(column.id);
            });
            this.displayedColumns = displayedColumns
          }
        }        
      })
    }
  }
  transformValue(col:AnalyticsColumn, val): any{
    return this.analyticsService.transformValue(col, val);
  }
  onExecute(query:IAnalyticQuery){
    this.dataSource.loadData(query);
  }
  public get pageInfo(){
    return this.dataSource?this.dataSource.pageInfo:null;
  }
  public get pageSizeOptions(): number[]{
    return this.dataSource? this.dataSource.pageSizeOptions: null;
  }
}
